import moment from "moment/moment";
window._ = require('lodash');

/**
 * Load frameworks!
 */
const bootstrap = require('bootstrap');
window.bootstrap = bootstrap;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import {currentLanguage} from "./services/CalendarLocaleSQ";

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    // broadcaster: process.env.MIX_BROADCASTER,
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

if (navigator.serviceWorker && !navigator.serviceWorker.controller) {
    navigator.serviceWorker.register("/sw.js").then(function (reg) {
        console.log("Service worker has been registered for scope: " + reg.scope);
    });
}

window.trans = require('./VueTranslation/Translation').default.translate;

const lang = document.documentElement.lang
if(lang !== 'en') require(`moment/locale/` + lang);

moment.updateLocale(lang, {
    week: {dow: 1}
});

const loader = document.getElementById('loader');
document.addEventListener("DOMContentLoaded", () => {
    loader?.classList?.add('d-none');
});
addEventListener('beforeunload', (event) => {
    loader?.classList?.remove('d-none');
});

